import { User } from 'lib-shared-types-api';
import { UserRole } from 'lib-shared-user-role';

/**
 * Checks whether a user has a certain role.
 *
 * @deprecated Use the `access-control` library instead.
 * @param user The user object.
 * @param role The role to check.
 */
export function userHasRole(user: User, role: UserRole): boolean {
  // Not all roles might be backfilled, such as team lead or system admin.
  // We can however safely test against admin role first, the highest role
  // possible. Otherwise test against the supplied role in which case we know
  // for sure that the role is there.
  return user.roles.includes('admin') || user.roles.includes(role);
}
